import React from 'react';
import { Card, CardActions } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';

import Input from 'react-toolbox/lib/input';
import { Button } from 'react-toolbox/lib/button';
import Dropdown from 'react-toolbox/lib/dropdown';

import { list, remove } from '~/actions/kits';
import dynamicSort from '~/utils/dynamicSort';
import { convertGramsToLbs } from '~/utils/weight';

import Dialog from '~/components/Dialog';

import Create from './create';
import Styles from './users.scss';

const orderByStates = [
  { value: 'name', label: 'Name' },
  { value: 'sku', label: 'Sku' },
  { value: 'toSku', label: 'To sku' },
  { value: 'count', label: 'Quantity' },
  { value: 'weight', label: 'Weight' }
];

class Kits extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      orderBy: 'name',
      search: '',
      showEdit: false,
      editPack: null
    };
  }
  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
  }
  toggleEdit(editPack) {
    this.setState({ editPack, showEdit: !this.state.showEdit });
  }
  toggleCreate() {
    this.setState({ editPack: null, showCreate: !this.state.showCreate });
  }
  remove(pack) {
    remove(this.props.dispatch, this.context.apiClient, pack.sku);
  }
  edit(pack) {
    this.toggleEdit(pack);
  }
  renderKits(kits) {
    const { search } = this.state;
    const seekRegex = new RegExp(search, 'i');

    return kits.map(item => {
      if (seekRegex.exec(item.name)) {
        return (
          <tr key={item.packId}>
            <td>
              <div className={Styles.spacer} />
            </td>
            <td>{item.name}</td>
            <td>{item.sku}</td>
            <td>{item.toSku}</td>
            <td>{convertGramsToLbs(item.weight)}</td>
            <td>{item.count}</td>
            <td>
              <Button
                icon="edit"
                label="Edit"
                primary
                onClick={() => {
                  this.edit(item);
                }}
              />

              <Button
                icon="close"
                label="Remove"
                primary
                onClick={() => {
                  this.remove(item);
                }}
              />
            </td>
          </tr>
        );
      }
      return false;
    });
  }
  render() {
    const listOfKits = (this.props.list && this.props.list.toJS()) || false;
    listOfKits.sort(dynamicSort(this.state.orderBy));
    return (
      <div className={Styles.content}>
        <div className={Styles.actionBar}>
          <div className={Styles.searchBox}>
            <Input
              type="text"
              label="Search"
              icon="search"
              value={this.state.search}
              onChange={e => this.setState({ search: e })}
            />
          </div>
          <div className={Styles.actionBox}>
            <Dropdown
              label="Order by"
              auto
              onChange={orderBy => this.setState({ orderBy })}
              source={orderByStates}
              value={this.state.orderBy}
            />
          </div>
        </div>

        <Dialog
          active={this.state.showCreate}
          onEscKeyDown={() => this.toggleCreate()}
          onOverlayClick={() => this.toggleCreate()}
          onCloseButtonClick={() => this.toggleCreate()}
          title="Create kit"
        >
          <Create
            done={() => {
              this.toggleCreate();
            }}
            pack={null}
          />
        </Dialog>

        <Dialog
          active={this.state.showEdit}
          onEscKeyDown={() => this.toggleEdit()}
          onOverlayClick={() => this.toggleEdit()}
          onCloseButtonClick={() => this.toggleEdit()}
          title="Edit kit"
        >
          <Create
            done={() => {
              this.toggleEdit();
            }}
            pack={this.state.editPack}
          />
        </Dialog>

        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Kits</div>
            <table className={Styles.table}>
              <thead>
                <tr>
                  <th>
                    <div className={Styles.spacer} />
                  </th>
                  <th>Name</th>
                  <th>Kit sku</th>
                  <th>Single sku</th>
                  <th>Weight</th>
                  <th>Qty</th>
                  <th />
                </tr>
              </thead>
              <tbody>{listOfKits && this.renderKits(listOfKits)}</tbody>
            </table>
            <CardActions>
              <Button
                icon="create"
                label="Create Kit"
                primary
                onClick={() => {
                  this.toggleCreate();
                }}
              />
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.getIn(['kits', 'list'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(Kits);



// WEBPACK FOOTER //
// ./app/pages/Kits/index.js